import {Dispatch, SetStateAction} from "react";
import {useCategoriesQuery} from "@generated/graphql";
import {Category} from "../../types";
import CategoryAccordion from "./CategoryAccordion";
import CircularLoading from "components/CircularLoading";
import {Box} from "@mui/material";
import useMaterialType from "pages/Material/useMaterialType";

export interface CategoryListProps {
  selectedCategory: Category | null;
  setSelectedCategory: Dispatch<SetStateAction<Category | null>>;
  selectedSubcategory: string;
  setSelectedSubcategory: Dispatch<SetStateAction<string>>;
  onClose?: () => void;
}

const CategoryList = ({
                        selectedCategory,
                        setSelectedCategory,
                        selectedSubcategory,
                        setSelectedSubcategory,
                        onClose
                      }: CategoryListProps) => {
  const materialType = useMaterialType()

  const {data: categories, loading: loadingCategories} = useCategoriesQuery({
    variables: {
      filter: {
        type: materialType
      },
      pagination: {page: 0, limit: 100}
    }
  });

  const categoryList = categories?.categories.data;

  if (loadingCategories) return <CircularLoading/>;

  return (
    <Box sx={{
      maxHeight: 700,
      overflow: 'auto',
    }}>
      {categoryList?.map((category) => (
        <CategoryAccordion
          key={category.id}
          category={category}
          selectedCategory={selectedCategory}
          selectedSubcategory={selectedSubcategory}
          setSelectedCategory={setSelectedCategory}
          setSelectedSubcategory={setSelectedSubcategory}
          onClose={onClose}
        />
      ))}
    </Box>
  );
};

export default CategoryList;
